import type { ChatMessageResponseAllOfBasicInfo } from './chatMessageResponseAllOfBasicInfo';
import type { ChatMessageResponseAllOfSender } from './chatMessageResponseAllOfSender';
import type { ChatMessageResponseAllOfStatus } from './chatMessageResponseAllOfStatus';

export type ChatMessageResponseAllOf = {
  basicInfo?: ChatMessageResponseAllOfBasicInfo;
  /** 발신자 정보 */
  sender?: ChatMessageResponseAllOfSender;
  /** 메시지 상태 정보 */
  status?: ChatMessageResponseAllOfStatus;
};
